module.exports = __webpack_public_path__ + "img/block0.673c7bbb.png";